// ** Auth Endpoints
 const jwtDefaultConfig={
  loginEndpoint:   '/identity/authenticate',
  //refreshEndpoint: '/jwt/refresh-token',
  logoutEndpoint: '/identity/logout',

  // ** This will be prefixed in authorization header with token
  // ? e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // ** Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'userData',
  storageRefreshTokenKeyName: 'refreshToken'

}

export default jwtDefaultConfig


